<template>
  <el-dialog v-model="show" :show-close="false" :close-on-press-escape="false" :width="'678px'"
    :custom-class="'dialog-no-title dialog-full-transparent'" :close-on-click-modal="false">
    <div class="tech-edit-window">
      <img src="@/assets/images/Tan/pop/interest/close.png" class="close" @click="close" />
      <p class="p-0">完善企业技术信息获取精准推荐</p>
      <el-form style="width: 500px;" ref="ruleFormRef" :model="form" :rules="formRules">
        <el-form-item prop="area">
          <div class="form-item">
            <div class="item-title">
              <span>*</span>选择所属行业领域：
            </div>
            <div class="right">
              <MultiSelection :selections="multiIndustry" :placeholder="'请选择，最多10个'" :max="10" :ref="'industrys'"
                class="no-wrap" style="width: 340px;" :value="form?.area" @sendValue="sendArea" v-if="!reInit"
                :noTip="true"></MultiSelection>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="mainProductService">
          <div class="form-item">
            <div class="item-title">
              <span>*</span>企业主要产品与服务：
            </div>
            <div class="right">
              <el-input v-model="form.mainProductService" style="width: 340px;" placeholder="请输入" maxlength="50" />
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="staffSize">
          <div class="form-item">
            <div class="item-title">
              <span>*</span>研发人员规模：
            </div>
            <div class="right">
              <el-select v-model="form.staffSize" placeholder="请选择" style="width: 340px;" clearable>
                <el-option v-for="(item, index) in staffList" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="fundsInput">
          <div class="form-item">
            <div class="item-title">
              <span>*</span>研发经费投入：
            </div>
            <div class="right">
              <el-select v-model="form.fundsInput" placeholder="请选择" style="width: 340px;" clearable>
                <el-option v-for="(item, index) in fundList" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>
        <div class="form-item">
          <div class="item-title">
            <span>*</span>是否有实验室：
          </div>
          <div class="right">
            <el-switch active-text="是" inactive-text="否" active-color="#23BF5D" style="padding-top: 10px;width: 100px;" v-model="form.laboratoryStatus">
            </el-switch>
          </div>
        </div>
        <el-form-item prop="researchDirection">
          <div class="form-item">
            <div class="item-title">
              <span>*</span>企业研究方向：
            </div>
            <div class="right">
              <el-input v-model="form.researchDirection" style="width: 340px;" placeholder="请输入" maxlength="50" />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <p @click="confirm" v-loading="btnLoading" class="confirm">获取资源推荐</p>
    </div>
  </el-dialog>
</template>

<script>
import MultiSelection from '@/components/MultiSelection/MultiSelection';
import { mapGetters } from "vuex";
import { getTanId, getTanLocalInfo } from "@/utils/Tan/login";
import { getTanCompanyInfo, editTanCompanyInfoApp, } from "@/api/Tan/company";
import { getSelectFatherSonByType } from "@/api/config";
import { ElMessage } from 'element-plus';

export default {
  components: {
    MultiSelection,
  },
  data() {
    return {
      show: false,
      multiIndustry: [],
      staffList: ['10人以下', '10-50人', '50人-100人', '100人以上'],
      fundList: ["100万以下", "100万-500万", "500万-1000万", "1000万-5000万", "5000万以上"],
      reInit: false,
      loading: false,
      btnLoading: false,
      formRules: {
        area: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        mainProductService: [
          { required: true, message: '请填写', trigger: 'blur' },
        ],
        staffSize: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        fundsInput: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        researchDirection: [
          { required: true, message: '请填写', trigger: 'blur' },
        ],
      },
      form: {
        area: '',
        mainProductService: '',
        staffSize: '',
        fundsInput: '',
        laboratoryStatus: false,
        researchDirection: '',
      }
    }
  },
  computed: {
    ...mapGetters([
      "TanCompanyTechEditPopShow",
    ]),
  },
  watch: {
    TanCompanyTechEditPopShow(val) {
      this.show = val
      if (val) {
        this.getInfo()
        this.getSelections()
      }
      else {
        this.resetForm()
      }
    },
  },
  methods: {
    confirm() {
      if (!this.form.area) {
        ElMessage.warning('请选择所属行业领域')
        return
      }
      else if (!this.form.mainProductService) {
        ElMessage.warning('请填写企业主要产品与服务')
        return
      }
      else if (!this.form.staffSize) {
        ElMessage.warning('请选择研发人员规模')
        return
      }
      else if (!this.form.fundsInput) {
        ElMessage.warning('请选择研发经费投入')
        return
      }
      else if (!this.form.researchDirection) {
        ElMessage.warning('请填写企业研究方向')
        return
      }
      this.btnLoading = true
      editTanCompanyInfoApp({
        area: this.form.area,
        mainProductService: this.form.mainProductService,
        staffSize: this.form.staffSize,
        fundsInput: this.form.fundsInput,
        laboratoryStatus: this.form.laboratoryStatus ? 1 : 0,
        researchDirection: this.form.researchDirection,
        "memberId": getTanId(),
        "tjCompanyId": getTanLocalInfo()?.tjInfo.tjCompanyId,
      }).then(res => {
        if (res.data) {
          ElMessage.success('修改成功')
          this.$store.dispatch('Tan/changeCompanyTechEditUpdate')
          this.close()
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    resetForm() {
      this.form = {
        area: '',
        mainProductService: '',
        staffSize: '',
        fundsInput: '',
        laboratoryStatus: false,
        researchDirection: '',
      }
      this.reInit = true
      setTimeout(() => {
        this.reInit = false
      }, 300)
    },
    sendArea(val) {
      this.form.area = val.map(item => {
        return item[item.length - 1]
      }).join(',')
    },
    getSelections() {
      getSelectFatherSonByType(6).then(res => {
        this.multiIndustry = res.data.map((item) => {
          item.child = item.child?.map((jtem) => {
            jtem.id = jtem.val
            return jtem
          })
          item.id = item.val
          return item
        })
      })
    },
    getInfo() {
      if (this.loading) {
        return
      }
      this.loading = true
      this.reInit = true
      getTanCompanyInfo(getTanId()).then((res) => {
        this.form.area = res.data.area || ''
        this.form.area = this.form.area.replace(/，/g,',')
        this.form.area = this.form.area.replace(/ /g,',')
        this.form.mainProductService = res.data.mainProductService || ''
        this.form.staffSize = res.data.staffSize || ''
        this.form.fundsInput = res.data.fundsInput || ''
        this.form.laboratoryStatus = res.data.laboratoryStatus + '' === '1' ? true : false
        this.form.researchDirection = res.data.researchDirection || ''
      }).finally(() => {
        this.loading = false
        this.reInit = false
      })
    },
    close() {
      this.$store.dispatch('Tan/setCompanyTechEditShow', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.tech-edit-window {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 46px;
  background-color: #FFFFFF;
  border-radius: 10px;
  padding-bottom: 42px;
  position: relative;
  :deep(.el-switch){
    .is-active{
      color: #303133;
    }
  }
  :deep(.el-form-item){
    margin-bottom: 0;
  }
  :deep(.el-form-item__error){
    top: 20px;
    left: 102%;
    white-space: nowrap;
  }
  .p-0 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    text-align: center;
    padding-bottom: 18px;
  }

  .close {
    position: absolute;
    width: 24px;
    height: 24px;
    right: 18px;
    top: 16px;
    cursor: pointer;
  }

  .confirm {
    width: 172px;
    height: 32px;
    background: $--color-theme;
    border-radius: 3px;
    margin-top: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
  }

  .form-item {
    width: 100%;
    display: flex;
    padding: 10px 0;
    justify-content: center;
    :deep(.el-select__tags-text) {
      font-size: 14px;
    }

    .item-title {
      width: 150px;
      height: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #111111;
      line-height: 14px;
      text-align: right;
      padding-top: 13px;

      span {
        color: #EC3E37;
      }
    }

    .right {
      width: 340px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      :deep(.input) {
        width: 340px !important;
      }
    }
  }

  .no-wrap {
    :deep(.el-select__tags) {
      white-space: nowrap;
      overflow: hidden;
    }

    :deep(.el-cascader__tags) {
      flex-wrap: nowrap !important;
      overflow: hidden;
    }
  }
}
</style>